module.exports = {
    0: '-',
	29: 'สบ.ทอ.',
	49: 'กพ.ทอ.',
	90: 'ขว.ทอ.',
	165: 'ยก.ทอ.',
	202: 'กบ.ทอ.',
	258: 'กร.ทอ.',
	283: 'ทสส.ทอ.',
	312: 'สปช.ทอ.',
	339: 'กง.ทอ.',
	390: 'สตน.ทอ.',
	430: 'สนภ.ทอ.',
	453: 'สธน.ทอ.',
	221286: 'คปอ.',
	4040: 'อย.',
	4586: 'ชอ.',
	5245: 'สอ.ทอ.',
	5422: 'สพ.ทอ.',
	5612: 'พอ.',
	5773: 'พธ.ทอ.',
	5908: 'ชย.ทอ.',
	6136: 'ขส.ทอ.',
	6346: 'ยศ.ทอ.',
	6562: 'สก.ทอ.',
	6610: 'ศวอ.ทอ.',
	6648: 'สวบ.ทอ.',
	6675: 'สน.ผบ.ดม.',
	220026: 'ศปอว.ทอ.'
};